module.exports = "/_next/static/images/marketing-sales-media-2f8114828d21210b19fcf09f704419c9.png";